'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024$0024anon$0024140 from "./presto.types$-U-R-L$$anon$140.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024$0024anon$0024141 from "./presto.types$-U-R-L$$anon$141.js";
import * as $j_presto$002etypes$0024$002dU$002dR$002dL$0024$0024anon$0024142 from "./presto.types$-U-R-L$$anon$142.js";
var $p;
/** @constructor */
function $c_Lpresto_types$URL$() {
  this.cea = null;
  this.ceb = false;
  this.ce8 = null;
  this.ce9 = false;
  this.cec = null;
  this.ced = false;
  this.cee = null;
  this.cef = false;
  this.ce6 = null;
  this.ce7 = false;
  this.ce4 = null;
  this.ce5 = false;
}
export { $c_Lpresto_types$URL$ as $c_Lpresto_types$URL$ };
$p = $c_Lpresto_types$URL$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$URL$;
/** @constructor */
function $h_Lpresto_types$URL$() {
}
export { $h_Lpresto_types$URL$ as $h_Lpresto_types$URL$ };
$h_Lpresto_types$URL$.prototype = $p;
$p.pi = (function() {
  if ((!this.ceb)) {
    this.cea = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().aC;
    this.ceb = true;
  }
  return this.cea;
});
$p.fi = (function() {
  if ((!this.ce9)) {
    this.ce8 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().a9;
    this.ce9 = true;
  }
  return this.ce8;
});
$p.H9 = (function() {
  if ((!this.ced)) {
    this.cec = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((x) => x)), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.ced = true;
  }
  return this.cec;
});
$p.ctp = (function() {
  if ((!this.cef)) {
    this.cee = new $j_presto$002etypes$0024$002dU$002dR$002dL$0024$0024anon$0024140.$c_Lpresto_types$URL$$anon$140(this);
    this.cef = true;
  }
  return this.cee;
});
$p.csQ = (function() {
  if ((!this.ce7)) {
    this.ce6 = new $j_presto$002etypes$0024$002dU$002dR$002dL$0024$0024anon$0024141.$c_Lpresto_types$URL$$anon$141(this);
    this.ce7 = true;
  }
  return this.ce6;
});
$p.cIE = (function() {
  if ((!this.ce5)) {
    this.ce4 = new $j_presto$002etypes$0024$002dU$002dR$002dL$0024$0024anon$0024142.$c_Lpresto_types$URL$$anon$142(this);
    this.ce5 = true;
  }
  return this.ce4;
});
var $d_Lpresto_types$URL$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$URL$, "presto.types$URL$", ({
  a2G: 1,
  D: 1
}));
export { $d_Lpresto_types$URL$ as $d_Lpresto_types$URL$ };
var $n_Lpresto_types$URL$;
function $m_Lpresto_types$URL$() {
  if ((!$n_Lpresto_types$URL$)) {
    $n_Lpresto_types$URL$ = new $c_Lpresto_types$URL$();
  }
  return $n_Lpresto_types$URL$;
}
export { $m_Lpresto_types$URL$ as $m_Lpresto_types$URL$ };
//# sourceMappingURL=presto.types$-U-R-L$.js.map
